<button mat-stroked-button class="button button-navigation"
    (click)="emit_onClick($event)"
    [disabled]="_disabled$$()"
    disabledInteractive
    [matTooltipPosition]="tooltipPosition$$()"
    [matTooltip]="tooltip$$()"
    [color]="color$$()"
    [tabindex]="tabIndex$$()"
>
    <div class="content">
        <ng-content />
    </div>
</button>
